// extracted by mini-css-extract-plugin
export default {"back":"pdf-viewer_back__8SI2E"};